export const EmployeeContractActionBarVI = {
    "employeeContractActionBar": {
        "header": {
            "detail": "Chi tiết hợp đồng"
        },
        "tab": {
            "detail":"Chi tiết",
            "fileAttach": "Đính kèm"
        },
        "item": {
            "delete": "Xóa",
            "auditing": "Lịch sử hoạt động",
            "update": "Cập nhật",
            "approval": "Duyệt",
            "back": "Quay về",
            "undoApproval": "Hoàn duyệt",
            "liquidation": "Thanh lý",
            "edit": "Sửa",
            "history": "Lịch sử",
        },
        "message": {
            "deleteAsk": "Bạn có chắc chắn muốn xóa hợp đồng ?",
            "approvalAsk": "Bạn có chắc chắn muốn duyệt hợp đồng ?",
            "undoApprovalAsk": "Bạn có chắc muốn hoàn duyệt không?",
            "liquidationAsk": "Bạn có chắc muốn thanh lý hợp đồng không?",
        }
    }
}
